import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import './ItemList.scss';
import seeMoreProv from '../../../images/see_more_prov.png';
import deleteProv from '../../../images/delete_prov.png';
import editProv from '../../../images/edit_prov.png';
import resetPass from '../../../images/lock-solid.svg';
import {useHistory} from 'react-router-dom';
import actions from '../../../redux/actions';
import sort from '../../../images/sort-solid.svg';
import sortUp from '../../../images/sort-up.svg';
import sortDown from '../../../images/sort-down.svg';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import {Tooltip} from '@mui/material';

/**
 * @description
 * @param { object } props no redux
 * @return { * } component
 */

const LenderHeader = ({data, isAdminList, sortList, sortParam}) => {
    const sortImgByHeader = (param) => {
        const value = sortParam.find((e) => e.param === param);
        return value ? (value.ord === 'asc' ? sortUp : sortDown) : sort;
    };

    return (
        <thead>
            {data && !isAdminList ?
                <tr className="il-lh-tr">
                    <td className="il-lh-td-lender il-lh-td-sortable" title={data.lender}
                        onClick={() => sortList('name')} id='name'
                    >
                        {data.lender}
                        <img src={sortImgByHeader('name')} alt={'sort'} className="il-sort-btn"/>
                    </td>
                    <td className="il-lh-td-data" id='phoneNumbers[0].number'>{data.data1}</td>
                    <td className="il-lh-td-email" id='user.email' >{data.data2}</td>
                    <td className="il-lh-td-code il-lh-td-sortable"
                        onClick={() => sortList('salesforceProviderName')} id='provider.name'
                    >
                        {data.venue}
                        <img src={sortImgByHeader('salesforceProviderName')} alt={'sort'} className="il-sort-btn"/>
                    </td>
                    <td className="il-lh-td-code il-lh-td-sortable"
                        onClick={() => sortList('salesforceBranchName')} id='branch.name'
                    >
                        {data.branch}
                        <img src={sortImgByHeader('salesforceBranchName')} alt={'sort'} className="il-sort-btn"/>
                    </td>
                    <td className="il-lh-td-data"></td>
                </tr> :
                <tr className="il-lh-tr">
                    <td className="il-lh-td-admin il-lh-td-sortable" title={data.email}
                        onClick={() => sortList(sortParam === 'email' ? 'email:desc' : 'email')} id='admin'
                    >
                        {data.email}
                        <img src={sortParam === 'email'? sortUp : sortParam === 'email:desc' ? sortDown : sort} alt={'sort'} className="il-sort-btn"/>
                    </td>
                    <td className="il-lh-td-admin-name il-lh-td-sortable" title={data.firstName}
                        onClick={() => sortList(sortParam === 'firstName' ? 'firstName:desc' : 'firstName')} id='admin-name'
                    >
                        {data.firstName}
                        <img
                            src={sortParam === 'firstName'? sortUp : sortParam === 'firstName:desc' ? sortDown : sort}
                            alt={'sort'} className="il-sort-btn"/>
                    </td>
                    <td className="il-lh-td-admin-lastname il-lh-td-sortable" title={data.lastName}
                        onClick={() => sortList(sortParam === 'lastName' ? 'lastName:desc' : 'lastName')} id='admin-lastname'
                    >
                        {data.lastName}
                        <img
                            src={sortParam === 'lastName'? sortUp : sortParam === 'lastName:desc' ? sortDown : sort}
                            alt={'sort'} className="il-sort-btn"/>
                    </td>
                    <td className="il-lh-td-empty"></td>
                </tr>
            }
        </thead>
    );
};

const LenderData = ({data, setProviderSelected, handleDelete, handleResetPass, isAdmin, isAdminList}) => {
    const history = useHistory();
    const pushPage = (name) => {
        history.push(name);
    };
    useEffect(() => {
        // effect
    }, [isAdmin]);
    return (
        <>
            {data && !isAdminList ?
            <tr className="il-ld-tr">
                <td className="il-lh-td-code">{sliceWord(data.name)}</td>
                <td className="il-ld-td-data">
                    {data.phoneNumbers ? data.phoneNumbers[0]?.number : ''}
                    <b>{data.phoneNumbers?.length>1 && (' +'+ (data.phoneNumbers.length-1) ) }</b>
                </td>
                <td className="il-lh-td-email">
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginRight: 20}}>
                        <text>{data.user?.email}</text>
                        <Tooltip title={'Administrador de prestador'}>
                            <text>
                                {data.user?.role?.name === 'PROVIDER_ADMIN' && <SupervisorAccountIcon/>}
                            </text>
                        </Tooltip>
                    </div>
                </td>
                <td className="il-ld-td-code" title={data.salesforceProviderName} >{data.salesforceProviderName}</td>
                <td className="il-ld-td-code" title={data.salesforceBranchName} >{data.salesforceBranchName ? data.salesforceBranchName : '-'}</td>
                <td className="il-ld-td-data">
                    <div className="il-div-bottom">
                        <button onClick={() => {
                            setProviderSelected(data);
                            pushPage('view');
                        }}
                        ><img src={seeMoreProv} alt={'view'}/></button>
                        <button onClick={() => {
                            handleDelete(data);
                        }}><img src={deleteProv} alt={'delete'}/></button>
                        <button onClick={() => {
                            setProviderSelected(data);
                            pushPage('edit');
                        }}><img src={editProv} alt={'edit'}/></button>
                        <button onClick={() => {
                            handleResetPass(data);
                        }}><img src={resetPass} alt={'resetPass'}/></button>
                    </div>
                </td>
            </tr> :
            <tr className="il-ld-tr">
                <td className="il-ld-td-admin">{data.email}</td>
                <td className="il-lh-td-admin-name">{data.firstName }</td>
                <td className="il-lh-td-admin-lastname">{data.lastName}</td>
                <td className="il-ld-td-data">
                    <div className="il-div-bottom">
                        <button onClick={() => {
                            handleDelete(data);
                        }}><img src={deleteProv} alt={'delete'}/></button>
                        <button onClick={() => {
                            handleResetPass(data);
                        }}><img src={resetPass} alt={'resetPass'}/></button>
                    </div>
                </td>
            </tr>
            }
        </>
    );
};


const ItemList = (props) => {
    const {
        type,
        data,
        setProviderSelected,
        setAdminSelected,
        handleDelete,
        handleResetPass,
        isAdmin,
        isAdminList,
        sortList,
        sortParam,
    } = props;
    const [typeList] = useState(['lender-header', 'lender-data']);
    const [itemFunction, setItemFunction] = useState([]);
    const [ind, setInd] = useState();

    useEffect(() => {
        type && setInd(typeList.indexOf(type));
        // eslint-disable-next-line
    }, [type]);

    useEffect(() => {
        // eslint-disable-next-line react/jsx-key
        setItemFunction([<LenderHeader data={data} isAdminList={isAdminList} sortList={sortList||null} sortParam={sortParam}/>,
            // eslint-disable-next-line react/jsx-key
            <LenderData
                data={data}
                setProviderSelected={setProviderSelected}
                setAdminSelected={setAdminSelected}
                handleDelete={handleDelete}
                handleResetPass={handleResetPass}
                isAdmin={isAdmin}
                isAdminList={isAdminList}/>,
        ]);
        // eslint-disable-next-line
    }, [data, isAdmin]);

    return (
        <>
            {
                data && type && itemFunction.length >= 0 && itemFunction[ind]
            }
        </>
    );
};

const sliceWord = (word) => {
    if (!word) return undefined;
    if (word.length > 20) {
        if (word.substring(20) !== ' ') {
            const auxWord = word.slice(0, 20);
            return `${auxWord.slice(0, auxWord.lastIndexOf(' '))}...`;
        }
    }
    return word;
};

ItemList.propTypes = {};

const mapStateToProps = (state) => ({
    providerSelected: state.home.providerSelected,
});

const mapDispatchToProps = (dispatch) => ({
    setProviderSelected: (providerSelected) => dispatch(actions.home.setProviderSelected(providerSelected)),
    setAdminSelected: (adminSelected) => dispatch(actions.home.setAdminSelected(adminSelected)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ItemList);

